import * as React from 'react';
import { IconButton, Typography } from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Reviews } from '../../types/blocks/reviews';
import { ReviewsList } from '../elements/reviews-list';
import { commonSwiperConfig } from '@/shared/utils';

interface SectionReviewsProps {
  element: Reviews;
}

export const SectionReviews: React.FC<SectionReviewsProps> = ({ element }) => {
  const swiperRef = React.useRef<any>(null);
  const [isBeginning, setIsBeginning] = React.useState(true);
  const [isEnd, setIsEnd] = React.useState(false);

  const handleSlideChange = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div
      className="py-24 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/homepage/reviews-background.svg')" }}
    >
      <div className="text-center space-y-10 max-w-[1264px] mx-auto">
        <div className="space-y-2 max-w-[750px] mx-auto px-4">
          <Typography variant="h1" component="h2" color="textPrimary">
            {element.title}
          </Typography>
          <Typography variant="s1" component="p" color="textSecondary">
            {element.description}
          </Typography>
        </div>

        {!!element.cards?.[0] && (
          <div className="mt-28 relative">
            <div className={`${isEnd ? 'ml-[-16px] mr-4 ' : 'pl-4'} md:mx-4 lg:mx-0`}>
              <Swiper
                {...commonSwiperConfig}
                modules={[Navigation]}
                spaceBetween={16}
                slidesPerView={1.2}
                breakpoints={{
                  768: { slidesPerView: 2, slidesPerGroup: 2 },
                  1060: { slidesPerView: 3, slidesPerGroup: 3 },
                }}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                }}
                onSlideChange={handleSlideChange}
                grabCursor={true}
                autoHeight={false}
                className="h-full"
              >
                {element.cards[0].trustpilotReviews.map((review, index) => (
                  <SwiperSlide key={review.id || index} className="h-full flex">
                    <ReviewsList reviews={[review]} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="hidden md:flex gap-2 items-center justify-center mt-4">
              <IconButton
                color="inherit"
                onClick={() => swiperRef.current?.slidePrev()}
                disabled={isBeginning} // Disable at first slide
              >
                <ChevronLeftRounded />
              </IconButton>
              <IconButton
                color="inherit"
                onClick={() => swiperRef.current?.slideNext()}
                disabled={isEnd} // Disable if at last slide
              >
                <ChevronRightRounded />
              </IconButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
